import { VIDEO_EXTENSIONS } from 'helpers/constants/fileExtensions';
import AbstractRequest from './AbstractRequest';
import { ApiMethod } from './constants';
import AuthClientStore from '../clientStore/AuthClientStore';
import { FileResponse } from './types/file';
import {
  AWS_S3_CDN_ENDPOINT,
  EXMINDS_API_HOST,
  EXMINDS_API_PORT,
  EXMINDS_API_PROTOCOL,
  IS_DEV_APP_ENVIRONMENT,
} from '../helpers/constants/envVars';

export interface ApiResponseUploadFile {
  id: string;
  extension: string;
  mimetype: string;
  name: string;
  path: string;
  fallbackPath?: string;
  size: string;
  uploaderId: string;
}
export interface MessageFile extends ApiResponseUploadFile {
  metadata: MessagePhotoMetadata;
}

export interface MessagePhotoMetadata extends ApiResponseUploadFile {
  photo: {
    hasBeenCompressed: boolean;
    initialExtension: string;
    initialMimetype: string;
    initialSize: number;
  };
}

export class FileRequest extends AbstractRequest {
  get apiResource(): string {
    return 'file';
  }

  get routes(): Record<string, string> {
    return {
      UPLOAD_FILE: `${this.apiRoute}/upload`,
    };
  }

  async uploadFile(
    file: File,
    onUploadProgress: CallbackFunction = () => null
  ): Promise<ApiResponseUploadFile> {
    const formData = new FormData();
    formData.append('file', file);

    const response = await this.request(
      ApiMethod.POST,
      this.routes.UPLOAD_FILE!,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${AuthClientStore.getToken()}`,
        },
        onUploadProgress,
      }
    );

    return response?.data;
  }

  getPublicUrl(file: FileResponse, isChatFile?: boolean): string {
    if (!file?.path) {
      console.warn('No file path provided.');
      return '';
    }
    const FILE_SIZE_THRESHOLD_MB = 50 * 1024 * 1024;

    let filePath = file.path.replace(/ /g, '%20');

    if (IS_DEV_APP_ENVIRONMENT) {
      filePath = filePath.replace('public/', '');
    }

    const BASE_URL = `${EXMINDS_API_PROTOCOL}://${EXMINDS_API_HOST}${
      EXMINDS_API_PORT ? `:${EXMINDS_API_PORT}` : ''
    }`;

    if (file.fileIsTranscoding) {
      console.log('File is currently transcoding, serving from server.');
      return `${BASE_URL}/${filePath}`.replace('public/', '');
    }

    if (isChatFile) {
      const isVideo = VIDEO_EXTENSIONS.includes(file.extension);
      if (isVideo && file.size > FILE_SIZE_THRESHOLD_MB) {
        return `${BASE_URL}/${filePath}`.replace('public/', '');
      }
    }

    return `${AWS_S3_CDN_ENDPOINT}/${filePath}`;
  }
}

export const fileRequest = new FileRequest();
